export const BoardData = {
    "2026-2027": {
        members: [
            {
                id: "Geneva-Flores-26",
                name: "Geneva Flores",
                position: "President",
                pronouns: "she/her",
                ipa: "[d͡ʒəˈnivə ˈfloɹɛs]",
                major: "Linguistics",
                minor: "Russian",
                gradYear: "2027",
                favoriteLingArea: "Semantic Processing",
                favoriteDrink: "Cold Brew",
                imageSrc: "/images/Board 2026-2027 Photos/geneva26.jpg",
            },

            {
                id: "Roocha-Thatte-26",
                name: "Roocha Thatte",
                position: "External Vice President",
                pronouns: "she/her",
                ipa: "[ ˈɾutɕa  ˈt̪ʰʌt̪ːe ]",
                major: "Linguistics",
                minor: "Data Science Engineering",
                gradYear: "2027",
                favoriteLingArea: "Etymology and Comparative Linguistics",
                favoriteDrink: "Matcha Einspanner",
                imageSrc: "/images/Board 2026-2027 Photos/roocha26.jpg",
            },
            
            {
                id: "Camille-Cosato-26",
                name: "Camille Cosato",
                position: "Internal Vice President",
                pronouns: "she/her",
                ipa: "[ kəˈmil kəˈsɑɾəʊ ]",
                major: "Linguistics + Computing Specialization",
                minor: "Spanish",
                gradYear: "2027",
                favoriteLingArea: "Speech Language Pathology and Syntax",
                favoriteDrink: "Iced Dirty Chai",
                imageSrc: "/images/Board 2026-2027 Photos/camille26.jpg",
            },

            {
                id: "Thomas-Scullin-26",
                name: "Thomas Scullin",
                position: "Treasurer",
                pronouns: "he/him",
                ipa: "[ ˈtɑmɪs ˈskʌlɪn ]",
                major: "Linguistics and Computer Science, Spanish and Portuguese",
                gradYear: "2027",
                favoriteLingArea: "Syntax",
                favoriteDrink: "Iced Latte with Banana Cream Cold Foam",
                imageSrc: "/images/Board 2026-2027 Photos/thomas26.jpg",
            },

            {
                id: "Naomi-Engle-26",
                name: "Naomi Engle",
                position: "Secretary",
                pronouns: "she/her",
                ipa: "[ ne͡ɪˈomi ˈe͡ɪŋgəɫ ]",
                major: "Linguistics and Psychology + Computing Specialization",
                gradYear: "2028",
                favoriteLingArea: "Neurolinguistics",
                favoriteDrink: "Caramel Ribbon Crunch Frappe",
                imageSrc: "/images/Board 2026-2027 Photos/naomi26.jpg",
            },

            {
                id: "Ana-Garcia-26",
                name: "Ana García Chávez",
                position: "Internal Events Coordinator",
                pronouns: "she/her",
                ipa: "[ ˈænæ gæɾˈsiæ ˈtʃævɛz ]",
                major: "Linguistics and Computer Science, Electrical Engineering",
                minor: "Data Science Engineering",
                gradYear: "2028",
                favoriteLingArea: "Computational Linguistics and NLP",
                favoriteDrink: "Thai Tea Boba",
                imageSrc: "/images/Board 2026-2027 Photos/ana26.jpg",
            },

            {
                id: "Nataly-Santiago-26",
                name: "Nataly Santiago",
                position: "Internal Events Coordinator",
                pronouns: "she/her",
                ipa: "[  ]",
                major: "",
                minor: "",
                gradYear: "",
                favoriteLingArea: "",
                favoriteDrink: "",
                imageSrc: "",
            },

            {
                id: "Alyssa-Pamintuan-26",
                name: "Alyssa Pamintuan",
                position: "External Events Coordinator",
                pronouns: "she/her",
                ipa: "[ əˈlɪs.ə paminˈtuʔan ]",
                major: "Linguistics and Psychology",
                minor: "Global Health",
                gradYear: "2027",
                favoriteLingArea: "Psycholinguistics",
                favoriteDrink: "Thai Milk Tea with Oreo",
                imageSrc: "/images/Board 2026-2027 Photos/alyssa26.jpg",
            },

            {
                id: "Doneay-Sheffield-26",
                name: "Doneay Sheffield",
                position: "External Events Coordinator",
                pronouns: "she/her",
                ipa: "[ dɑˈneɪ  ˈʃɛfild ]",
                major: "Applied Linguistics, Disability Studies",
                minor: "Education",
                gradYear: "2027",
                favoriteLingArea: "Syntax and Phonology",
                favoriteDrink: "Diet Coke with extra ice",
                imageSrc: "/images/Board 2026-2027 Photos/doneay26.jpg",
            },

            {
                id: "Jerry-Xiong-26",
                name: "Jerry Xiong",
                position: "Publicity",
                pronouns: "he/him",
                ipa: "[ 'd͡ʒɛɹi ɕi̯ɔŋ ]",
                major: "Linguistics and English",
                minor: "Creative Writing",
                gradYear: "2029",
                favoriteLingArea: "Sociolinguistics",
                favoriteDrink: "Iced Pumpkin Cream Chai",
                imageSrc: "/images/Board 2026-2027 Photos/jerry26.jpg",
            },

            {
                id: "Jocelynne-Cambonchi-26",
                name: "Jocelynne Cambonchi",
                position: "Publicity",
                pronouns: "she/her",
                ipa: "[ dʒɔsəlɪn kæmboʊntʃi ]",
                major: "Cognitive Science",
                minor: "Linguistics",
                gradYear: "2027",
                favoriteLingArea: "Syntax",
                favoriteDrink: "Jasmine Matcha Latte",
                imageSrc: "/images/Board 2026-2027 Photos/jocelynne26.jpg",
            },

            {
                id: "Gabriel-Scharff-26",
                name: "Gabriel Scharff",
                position: "Historian",
                pronouns: "he/him",
                ipa: "[ ˈgeɪ.bɹi.əl  ˈʃɑɹf ]",
                major: "Linguistics and Computer Science",
                gradYear: "2026",
                favoriteLingArea: "Syntax + Phonology",
                favoriteDrink: "Iced Mocha",
                imageSrc: "/images/Board 2025-2026 Photos/gabe25.jpg",
            },

            {
                id: "Olivia-Castillo-26",
                name: "Olivia Castillo",
                position: "Historian",
                pronouns: "she/her",
                ipa: "[ oʊˈɫɪviə ˌkæsˈtioʊ ]",
                major: "Applied Linguistics",
                minor: "Disability Studies",
                gradYear: "2027",
                favoriteLingArea: "Syntax",
                favoriteDrink: "Pumpkin Spice Latte",
                imageSrc: "/images/Board 2026-2027 Photos/olivia26.jpg",
            },

            {
                id: "Charlotte-Pham-26",
                name: "Charlotte Pham",
                position: "Web Development",
                pronouns: "she/her",
                ipa: "[ ˈʃaɹlɪt ˈfæm ]",
                major: "Linguistics and Computer Science",
                gradYear: "2029",
                favoriteLingArea: "Phonology and Psycholinguistics",
                favoriteDrink: "Strawberry Matcha Einspanner",
                imageSrc: "/images/Board 2026-2027 Photos/charlotte26.jpg",
            },

            {
                id: "Seher-Allahbachayo-26",
                name: "Seher Allahbachayo",
                position: "Web Development",
                pronouns: "she/her",
                ipa: "[ sɛˈhɛər ˌəl.lɑː.bəˈt͡ʃɑː.joʊ ]",
                major: "Linguistics and Computer Science",
                minor: "Geospatial Information Systems",
                gradYear: "2027",
                favoriteLingArea: "Semantics",
                favoriteDrink: "Iced Vanilla Latte with Banana Cold Foam",
                imageSrc: "/images/Board 2026-2027 Photos/seher26.jpg",
            },
        ],
    },
    "2025-2026": {
        members: [
            {
                id: "Roocha-Thatte-25",
                name: "Roocha Thatte",
                position: "President",
                pronouns: "she/her",
                ipa: "[ ˈɾutɕa  ˈt̪ʰʌt̪ːe ]",
                major: "Linguistics and Computer Science",
                gradYear: "2027",
                favoriteLingArea: "Historical Linguistics and Sociolinguistics",
                favoriteDrink: "Iced Vanilla Oat Latte",
                imageSrc: "/images/Board 2025-2026 Photos/roocha25.jpg",
            },
            {
                id: "YiTao-Li-25",
                name: "YiTao Li",
                position: "External Vice President",
                pronouns: "she/her",
                ipa: "[ i.ˈtaʊ  li ]",
                major: "Cognitive Science",
                minor: "Linguistics + Statistics and Data Science",
                gradYear: "2026",
                favoriteLingArea: "Etymology + Syntax",
                favoriteDrink: "Vanilla Oat Matcha Latte",
                imageSrc: "/images/Board 2025-2026 Photos/yitao25.jpg",
            },
            {
                id: "Anna-Tobey-25",
                name: "Anna Tobey",
                position: "Internal Vice President",
                pronouns: "she/her",
                ipa: "[ 'æ.nə  'toʊ.bi ]",
                major: "Linguistics",
                gradYear: "2026",
                favoriteLingArea: "Phonology + Syntax",
                favoriteDrink: "Peach Tea",
                imageSrc: "/images/Board 2025-2026 Photos/anna25.jpg",
            },

            {
                id: "Gabriel Scharff-25",
                name: "Gabriel Scharff",
                position: "Treasurer",
                pronouns: "he/him",
                ipa: "[ ˈgeɪ.bɹi.əl  ˈʃɑɹf ]",
                major: "Linguistics and Computer Science",
                gradYear: "2026",
                favoriteLingArea: "Syntax + Phonology",
                favoriteDrink: "Iced Mocha",
                imageSrc: "/images/Board 2025-2026 Photos/gabe25.jpg",
            },

            {
                id: "Geneva-Flores-25",
                name: "Geneva Flores",
                position: "Secretary",
                pronouns: "she/her",
                ipa: "[ d͡ʒəˈnivə  ˈfloɹɛs ]",
                major: "Linguistics",
                minor: "Russian Language",
                gradYear: "2027",
                favoriteLingArea: "Syntax, Semantics, Philosophy of language",
                favoriteDrink: "Caffe Macchiato",
                imageSrc: "/images/Board 2025-2026 Photos/geneva25.JPG",
            },

            {
                id: "Alyssa-Pamintuan-25",
                name: "Alyssa Pamintuan",
                position: "Historian",
                pronouns: "she/her",
                ipa: "[ əˈlɪs.ə  paminˈtuʔan ]",
                major: "Linguistics and Psychology",
                gradYear: "2027",
                favoriteLingArea: "Psycholinguistics",
                favoriteDrink: "Thai Milk Tea w/ Oreo",
                imageSrc: "/images/Board 2025-2026 Photos/alyssa25.jpg",
            },

            {
                id: "Cami-Cosato-25",
                name: "Cami Cosato",
                position: "Internal Event Coordinator",
                pronouns: "she/her",
                ipa: "",
                major: "Linguistics + Computing specialization",
                gradYear: "2027",
                favoriteLingArea: "Syntax",
                favoriteDrink: "Iced Dirty Chai Latte",
                imageSrc: "/images/Board 2025-2026 Photos/cami25.jpg",
            },
            {
                id: "Boyi-Zheng-24",
                name: "Boyi Zheng",
                position: "Internal Event Coordinator",
                pronouns: "he/him",
                ipa: "[ boˈ(ʔ)i ˈʈ͡ʂə̃ŋ ]",
                major: "M.A. Persian 2025, B.A. Linguistics and Religion",
                gradYear: "2026",
                favoriteLingArea: "Morphosemantics + Education",
                favoriteDrink: "Thai Tea",
                imageSrc: "/images/Board 2025-2026 Photos/boyi25.jpg",
            },

            {
                id: "Seher-Allahbachayo-25",
                name: "Seher Allahbachayo",
                position: "External Event Coordinator",
                pronouns: "she/her",
                ipa: "[ sɛhɛr ]",
                major: "Linguistics and Computer Science",
                gradYear: "2027",
                favoriteLingArea: "Language Acquisition",
                favoriteDrink: "Iced Vanilla Latte",
                imageSrc: "/images/Board 2025-2026 Photos/seher25.jpg",
            },

            {
                id: "Marian-Apanco-25",
                name: "Marian Apanco",
                position: "External Event Coordinator",
                pronouns: "she/her",
                ipa: "[ ˈmɛəriən  ɑˈpɑnkoʊ ]",
                major: "Linguistics and Psychology",
                gradYear: "2027",
                favoriteLingArea: "Phonetics",
                favoriteDrink: "Iced White Mocha",
                imageSrc: "/images/Board 2025-2026 Photos/marian25.jpg",
            },

            {
                id: "Maddi-Huie-25",
                name: "Maddi Huie",
                position: "Social Media & Marketing",
                pronouns: "",
                ipa: "[ mædi çjuːi ]",
                major: "Linguistics and Psychology",
                gradYear: "2026",
                favoriteLingArea: "Syntax!",
                favoriteDrink: "Mango Smoothie",
                imageSrc: "/images/Board 2025-2026 Photos/maddi25.jpg",
            },

            {
                id: "Naomi-Engle-25",
                name: "Naomi Engle",
                position: "Social Media & Marketing",
                pronouns: "she/her",
                ipa: "[ ne͡jˈoˌmi  ˈæŋˌɡəl ]",
                major: "Linguistics and Psychology + Computing",
                gradYear: "2028",
                favoriteLingArea: "Psycholinguistics + SLP",
                favoriteDrink: "Water with crunchy ice",
                imageSrc: "/images/Board 2025-2026 Photos/naomi25.jpg",
            },


        ],
    },
    "2024-2025": {
        members: [
            {
                id: "Emily-Foster-24",
                name: "Emily Foster",
                position: "President",
                pronouns: "she/her",
                ipa: "[ˈɛmɪli ˈfɑstəɹ ]",
                major: "Linguistics & Computer Science",
                minor: "",
                gradYear: "2026",
                favoriteLingArea: "Linguistic Anthropology",
                favoriteDrink: "Matcha Latte",
                imageSrc: "/images/Emily 23-24.jpeg",
            },
            {
                id: "Alicia-Liu<-24",
                name: "Alicia Liu",
                position: "Vice President",
                pronouns: "she/her",
                ipa: "[ əliʃə lioʊ ]",
                major: "Linguistics & Computer Science",
                minor: "",
                gradYear: "2026",
                favoriteLingArea: "Asian Languages + Syntax",
                favoriteDrink: "Matcha Latte",
                imageSrc: "/images/alicia.jpg",
            },
            {
                id: "Gareth-Yu-24",
                name: "Gareth Yu",
                position: "Treasurer",
                pronouns: "he/him",
                ipa: "[ 'gɛ.ɹɪθ  ju ]",
                major: "Linguistics and Psychology + Cognitive Science",
                minor: "Anthropology + Statistics and Data Science",
                gradYear: "2026",
                favoriteLingArea: "Psycholinguistics + Receptive Bilingualism",
                favoriteDrink: "Taro Milk Tea w/ Lychee Jelly",
                imageSrc: "/images/IMG_9876 - Gareth Yu.jpg",
            },
            {
                id: "Boyi-Zheng-24",
                name: "Boyi Zheng",
                position: "Secretary",
                pronouns: "he/him",
                ipa: "[ boˈ(ʔ)i ˈʈ͡ʂə̃ŋ ]",
                major: "M.A. Persian 2025, B.A. Linguistics and Religion",
                minor: "",
                gradYear: "2026",
                favoriteLingArea: "Morphosemantics + Education",
                favoriteDrink: "Thai Tea",
                imageSrc: "/images/Screenshot 2024-10-03 at 7.50.23 PM.png",
            },
            {
                id: "Anna-Tobey-24",
                name: "Anna Tobey",
                position: "Internal Event coordinator",
                pronouns: "she/her",
                ipa: "[ 'æ.nə  'toʊ.bi ]",
                major: "Linguistics",
                minor: "",
                gradYear: "2026",
                favoriteLingArea: "Phonology + Syntax",
                favoriteDrink: "Peach Tea",
                imageSrc: "/images/IMG_5411 - ANNA TOBEY.jpeg",
            },
            {
                id: "YiTao-Li-24",
                name: "YiTao Li",
                position: "Internal Event Coordinator",
                pronouns: "she/her",
                ipa: "[ i.ˈtaʊ  li ]",
                major: "Cognitive Science",
                minor: "Linguistics + Statistics and Data Science",
                gradYear: "2026",
                favoriteLingArea: "Etymology + Syntax",
                favoriteDrink: "Vanilla Oat Matcha Latte",
                imageSrc: "/images/grapes - yitao li.jpg",
            },
            {
                id: "Shayna-Rabin-24",
                name: "Shayna Rabin",
                position: "Social Media & Marketing",
                pronouns: "she/her",
                ipa: "[ ʃaɪ.nə  'ɹaɪ.bɪn ]",
                major: "Psychology + Education and Social Transformation",
                minor: "Linguistics",
                gradYear: "2025",
                favoriteLingArea: "Language Development + Processing",
                favoriteDrink: "Iced Matcha Latte w/ Oat Milk",
                imageSrc: "/images/shayna.jpg",
            },
            {
                id: "Remi-Akopian-24",
                name: "Remi Akopian",
                position: "External Event Coordinator",
                pronouns: "she/her",
                ipa: "[ ˈɹɛmi  əkʰoʊpiəns ]",
                major: "Linguistics & Computer Science",
                minor: "",
                gradYear: "2025",
                favoriteLingArea: "Application of Linguistics + Bilingualism",
                favoriteDrink: "Strawberry Einspenner @ Damo",
                imageSrc: "/images/HC9A0208 - Remi Akopians.JPG",
            },
            {
                id: "Sophie-Atkins-24",
                name: "Sophie Atkins",
                position: "External Event Coordinator",
                pronouns: "she/her",
                ipa: "[ soʊ.fi  ætkɪnz ]",
                major: "Linguistics & Psychology",
                minor: "German",
                gradYear: "2027",
                favoriteLingArea: "Psycholinguistics + Communication Disorders",
                favoriteDrink: "Iced Matcha Latte w/ Oat Milk",
                imageSrc: "/images/bling pic - SOPHIE ATKINS.jpeg",
            },
        ],
    },
    "2023-2024": {
        members: [
            {
                id: "Boyi-Zheng-23",
                name: "Boyi Zheng",
                position: "President",
                pronouns: "he/him",
                ipa: "[ boˈ(ʔ)i ˈʈ͡ʂə̃ŋ ]",
                major: "Applied Linguistics & Study of Religion",
                gradYear: "2024",
                favoriteLingArea: "Morphosemantics + Education",
                favoriteDrink: "Thai Tea",
                imageSrc: "/images//Board 2023-2024 Photos/Copy of IMG_1056 - BOYI ZHENG.jpg",
            },
            {
                id: "Noel-Guzman-23",
                name: "Noel Guzman",
                position: "Vice President",
                pronouns: "they/them",
                ipa: "[noʊˈwɛl gusˈman]",
                major: "Linguistics & Psychology",
                gradYear: "2025",
                favoriteLingArea: "Psycholinguistics",
                favoriteDrink: "Mango with Jelly",
                imageSrc: "/images/Board 2023-2024 Photos/Copy of Noel Guzman pfp - Noel Guzman.jpg",
            },
            {
                id: "Jean-Max-Fawzi-23",
                name: "Jean-Max Fawzi",
                position: "Treasurer",
                pronouns: "he/him",
                ipa: "[ˈʒɑ̃-mæks ˈfɔzi]",
                major: "Business-Economics & Linguistics Minor",
                gradYear: "2025",
                favoriteLingArea: "Historical Linguistics",
                favoriteDrink: "Protein Shake😤",
                imageSrc: "/images/Board 2023-2024 Photos/max.jpg",
            },
            {
                id: "Skylar-Wiggin-23",
                name: "Skylar Wiggin",
                position: "Secretary",
                pronouns: "",
                ipa: "[skaɪləɹ wɪgɪn]",
                major: "Linguistics & Psychology",
                gradYear: "2026",
                favoriteLingArea: "Phonology",
                favoriteDrink: "Moroccan Mint Tea",
                imageSrc: "/images/Board 2023-2024 Photos/PXL_20230925_220317079 - SKYLAR WIGGIN.jpg",
            },
            {
                id: "Danielle-Meza-23",
                name: "Danielle Meza",
                position: "Campus Representative",
                pronouns: "she/her",
                ipa: "[dænjɛl mesa]",
                major: "Linguistics & Psychology",
                gradYear: "2024",
                favoriteLingArea: "Syntax & Psycholinguistics",
                favoriteDrink: "Matcha Lemonade",
                imageSrc: "/images/Board 2023-2024 Photos/Copy of IMG_0508 - Danielle Meza.jpg",
            },
            {
                id: "Valerie-So-23",
                name: "Valerie So",
                position: "Campus Representative",
                pronouns: "she/her",
                ipa: "[væləri soʊ]",
                major: "Linguistics & Computer Science",
                gradYear: "2026",
                favoriteLingArea: "Syntax & Phonology",
                favoriteDrink: "Fruity Mocktails",
                imageSrc: "/images/Board 2023-2024 Photos/Copy of IMG-8264 - VALERIE SO.JPG",
            },
            {
                id: "Alicia-Liu-23",
                name: "Alicia Liu",
                position: "Event Coordinator",
                pronouns: "she/her",
                ipa: "[aliʃə lioʊ]",
                major: "Linguistics & Computer Science",
                gradYear: "2026",
                favoriteLingArea: "Psycholinguistics",
                favoriteDrink: "Matcha Latte",
                imageSrc: "/images/Board 2023-2024 Photos/Copy of 1213 - ALICIA LIU.jpg",
            },
            {
                id: "Olivia-Simons-23",
                name: "Olivia Simons",
                position: "Event Coordinator",
                pronouns: "she/her",
                ipa: "[oʊˈlɪviə sa͡ɪmənz]",
                major: "Political Science & Linguistics Minor",
                gradYear: "2024",
                favoriteLingArea: "Phonology",
                favoriteDrink: "Iced Latte",
                imageSrc: "/images/Board 2023-2024 Photos/Copy of bling headshot - Olivia Simons.jpg",
            },
            {
                id: "Emily-Foster-23",
                name: "Emily Foster",
                position: "Social Media & Marketing",
                pronouns: "she/her",
                ipa: "[ˈɛmɪli ˈfɑstəɹ ]",
                major: "Linguistics & Computer Science",
                gradYear: "2026",
                favoriteLingArea: "Historical Linguistics",
                favoriteDrink: "Matcha Latte",
                imageSrc: "/images/Emily 23-24.jpeg",
            },
        ],
    },
    "2022-2023": {
        members: [
            {
                id: "Jennifer-Miyaki-22",
                name: "Jennifer Miyaki",
                position: "President",
                major: "Linguistics DSP",
                gradYear: "2024",
                imageSrc: "/images/Board 2022-2023 Photos/Jennifer.png",
            },
            {
                id: "Isabelle-Altman-22",
                name: "Isabelle Altman",
                position: "Vice President",
                major: "Linguistics",
                gradYear: "2023",
                imageSrc: "/images/Board 2022-2023 Photos/isabelle.jpeg",
            },
            {
                id: "Jean-Max-Fawzi-22",
                name: "Jean-Max Fawzi",
                position: "Treasurer",
                major: "Business Economics & Linguistics Minor",
                gradYear: "2025",
                imageSrc: "/images/Board 2022-2023 Photos/Max.jpg",
            },
            {
                id: "Sean-Cunin-22",
                name: "Sean Cunin",
                position: "Secretary",
                major: "Linguistics & Computer Science",
                gradYear: "2023",
                imageSrc: "/images/Board 2022-2023 Photos/sean.jpg",
            },
            {
                id: "Noel-Guzman-22",
                name: "Noel Guzman",
                position: "Campus Representative",
                major: "Linguistics & Psychology",
                gradYear: "2025",
                imageSrc: "/images/Board 2022-2023 Photos/Noel.jpg",
            },
            {
                id: "Xiaoxuan-(Cindy)-Wang-22",
                name: "Xiaoxuan (Cindy) Wang",
                position: "Campus Representative",
                major: "Linguistics & Applied Math",
                gradYear: "2023",
                imageSrc: "/images/Board 2022-2023 Photos/Cindy.jpg",
            },
            {
                id: "Ryan-Tsai-22",
                name: "Ryan Tsai",
                position: "Event Coordinator",
                major: "Applied Linguistics",
                gradYear: "2023",
                imageSrc: "/images/Board 2022-2023 Photos/ryan.jpg",
            },
            {
                id: "Megan-McLane-22",
                name: "Megan McLane",
                position: "Event Coordinator",
                major: "Linguistics",
                gradYear: "2023",
                imageSrc: "/images/Board 2022-2023 Photos/Megan.jpg",
            },
            {
                id: "Meghana-Gorti-22",
                name: "Meghana Gorti",
                position: "Social Media & Marketing",
                major: "Linguistics & Computer Science",
                gradYear: "2024",
                imageSrc: "/images/Board 2022-2023 Photos/Meghana.jpg",
            },
        ],
    },
};
